import { Navigate, useParams } from 'react-router-dom';
import { getClientsLink } from '~/utils/getLinks';
import { ClientShowScreenContent } from './ClientShowScreenContent';

export const Screen: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const clientId = Number.parseInt(id || '', 10);

  if (Number.isNaN(clientId)) {
    return <Navigate to={getClientsLink()} replace />;
  }

  return <ClientShowScreenContent clientId={clientId} />;
};
